import { Component, forwardRef, Input, ChangeDetectionStrategy, inject } from "@angular/core";
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { AngularEditorConfig, AngularEditorModule } from "@kolkov/angular-editor";
import { HtmlSanitizerService } from "../../services/html-sanitzer.service";

@Component({
	selector: "rl-html-editor",
	templateUrl: "./html-editor.component.html",
	styleUrls: ["./html-editor.component.scss"],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => HtmlEditorComponent),
			multi: true
		}
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [AngularEditorModule, ReactiveFormsModule, FormsModule]
})
export class HtmlEditorComponent implements ControlValueAccessor {
	private readonly _htmlSanitizerService = inject(HtmlSanitizerService);

	@Input()
	set placeholder(placeholder: string) {
		this.editorConfig.placeholder = placeholder;
	}

	@Input()
	disabled = false;

	html: string;

	editorConfig: AngularEditorConfig = {
		editable: true,
		spellcheck: true,
		height: "250px",
		minHeight: "200px",
		maxHeight: "auto",
		width: "auto",
		minWidth: "0",
		translate: "yes",
		enableToolbar: true,
		showToolbar: true,
		placeholder: "",
		sanitize: false,
		toolbarPosition: "top",
	};

	onChange = (html: string) => {
		this.html = this.sanitizeHtml(html);
	};
	onTouched = () => { };

	writeValue(html: string): void {
		this.html = this.sanitizeHtml(html);
	}

	registerOnChange(fn: (value: unknown) => void): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}

	setDisabledState?(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}

	sanitizeHtml(html: string) {
		const sanitizedHtml = this._htmlSanitizerService.sanitizeWhilePreservingStyles(html);
		return sanitizedHtml;
	}
}
